import { useIntl } from 'react-intl';
import { useCallback, useMemo } from 'react';

import { CustomExtendedDataField } from '../../../../components';
import {
  AdditionalDimensionsFields,
  EngineFields,
  OtherEngineInformationFields,
  OtherInformationFields,
  OtherTrailerInformation,
  TrailerDimensions,
} from './EditListingDetailsFields';

export default function(params) {
  const { formId, configsByKey, formApi } = params;

  const intl = useIntl();

  const boatItems = useMemo(
    () => [
      {
        id: 0,
        label: 'EditListingDetailsForm.accordionEngineDetails',
        renderContent: () => (
          <EngineFields formId={formId} intl={intl} configsByKey={configsByKey} formApi={formApi} />
        ),
      },
      {
        id: 1,
        label: 'EditListingDetailsForm.accordionDimensionDetails',
        renderContent: () => (
          <AdditionalDimensionsFields formId={formId} intl={intl} configsByKey={configsByKey} category="boats" />
        ),
      },
      {
        id: 2,
        label: 'EditListingDetailsForm.accordionTechnicalEquipment',
        renderContent: () => (
          <CustomExtendedDataField
            formId={formId}
            fieldConfig={configsByKey?.technicalEquipment}
            name="pub_technicalEquipment"
            key="pub_technicalEquipment"
            intl={intl}
            twoColumns
          />
        ),
      },
      {
        id: 3,
        label: 'EditListingDetailsForm.accordionOnBoardInstruments',
        renderContent: () => (
          <CustomExtendedDataField
            formId={formId}
            fieldConfig={configsByKey?.onBoardInstruments}
            name="pub_onBoardInstruments"
            key="pub_onBoardInstruments"
            intl={intl}
            twoColumns
          />
        ),
      },
      {
        id: 4,
        label: 'EditListingDetailsForm.accordionGalley',
        renderContent: () => (
          <CustomExtendedDataField
            formId={formId}
            fieldConfig={configsByKey?.galley}
            name="pub_galley"
            key="pub_galley"
            intl={intl}
            twoColumns
          />
        ),
      },
      {
        id: 5,
        label: 'EditListingDetailsForm.accordionCoversAndTarpaulins',
        renderContent: () => (
          <CustomExtendedDataField
            formId={formId}
            fieldConfig={configsByKey?.coversAndTarpaulins}
            name="pub_coversAndTarpaulins"
            key="pub_coversAndTarpaulins"
            intl={intl}
            twoColumns
          />
        ),
      },
      {
        id: 6,
        label: 'EditListingDetailsForm.accordionEquipment',
        renderContent: () => (
          <CustomExtendedDataField
            formId={formId}
            fieldConfig={configsByKey?.equipment}
            name="pub_equipment"
            key="pub_equipment"
            intl={intl}
            twoColumns
          />
        ),
      },
    ],
    [formId, intl, configsByKey]
  );

  const smallBoatItems = useMemo(
    () => [
      {
        id: 0,
        label: 'EditListingDetailsForm.accordionEngineDetails',
        renderContent: () => (
          <EngineFields
            formId={formId}
            configsByKey={configsByKey}
            category="small-boats"
            formApi={formApi}
          />
        ),
      },
      {
        id: 1,
        label: 'EditListingDetailsForm.accordionDimensionDetails',
        renderContent: () => (
          <AdditionalDimensionsFields formId={formId} intl={intl} configsByKey={configsByKey} />
        ),
      },
      {
        id: 2,
        label: 'EditListingDetailsForm.accordionCoversAndTarpaulins',
        renderContent: () => (
          <CustomExtendedDataField
            formId={formId}
            fieldConfig={configsByKey?.coversAndTarpaulins}
            name="pub_coversAndTarpaulins"
            key="pub_coversAndTarpaulins"
            intl={intl}
            twoColumns
          />
        ),
      },
      {
        id: 3,
        label: 'EditListingDetailsForm.accordionOtherDetails',
        renderContent: () => (
          <OtherInformationFields
            formId={formId}
            configsByKey={configsByKey}
            category="small-boats"
            intl={intl}
          />
        ),
      },
    ],
    [formId, configsByKey, intl]
  );

  const engineItems = useMemo(
    () => [
      {
        id: 0,
        label: 'EditListingDetailsForm.otherEngineInformation',
        renderContent: () => (
          <OtherEngineInformationFields formId={formId} configsByKey={configsByKey} />
        ),
      },
    ],
    [configsByKey, formId]
  );

  const trailerItems = useMemo(
    () => [
      {
        id: 0,
        label: 'EditListingDetailsForm.trailerDimensions',
        renderContent: () => <TrailerDimensions formId={formId} configsByKey={configsByKey} />,
      },
      {
        id: 1,
        label: 'EditListingDetailsForm.otherTrailerInformation',
        renderContent: () => (
          <OtherTrailerInformation formId={formId} configsByKey={configsByKey} />
        ),
      },
    ],
    [formId, configsByKey]
  );

  return {
    boatItems,
    engineItems,
    smallBoatItems,
    trailerItems,
  };
}
